import { Component } from '@angular/core';
import { CrmVersionDetectorService } from 'common-module/version';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent {
  appUpdateAvailable$: Observable<boolean>;

  constructor(private swDetectorService: CrmVersionDetectorService) {
    this.appUpdateAvailable$ = swDetectorService.appUpdateAvailable$;
  }

  loadNewVersion() {
    this.swDetectorService.reloadApp();
  }
}
